import request from '@/router/axios';

export const getList = (current, size) => {
    return request({
        url: '/api/blade-dossier/dossierRecord/getList',
        method: 'get',
        params: {
            current,
            size,
        }
    })
}
export const basisListFollowUp = (id) => {
    return request({
        url: '/api/blade-basis/basisarchive/basisList/'+id,
        method: 'get'
    })
}

export const caseArchivedFollowUp = (id) => {
    return request({
        url: '/api/blade-basis/casearchived/caseArchived/'+id,
        method: 'get'
    })
}

export const addFollowUp = (row) => {
    return request({
        url: '/api/blade-basis/basisarchive/addBasisArchiveInterview',
        method: 'post',
        data: row
    })
}

export const addCaseFollowUp = (row) => {
    return request({
        url: '/api/blade-basis/casearchived/addCaseArchived',
        method: 'post',
        data: row
    })
}



export const getDetail = (id) => {
    return request({
        url: '/api/blade-dossier/dossierRecord/detail/' + id,
        method: 'get'
    })
}


export const remove = (id) => {
    return request({
        url: '/api/blade-basis/basisarchive/detailBy2/'+id,
        method: 'get'
    })
}
